<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div *ngIf="pricingState?.premiumDiscountNavViivHistory">
      <div edsSpacing="lg">
        <ft-pricing-chart
          [chartConfig]="pricingState.premiumDiscountNavViivHistory"
          [minDateStd]="pricingState.pricingConfig.dateValues.incDateStd"
          [maxDateStd]="pricingState.pricingConfig.dateValues.asOfDateStd"
          [navAsOfDate]="pricingState.overviewData.nav.navAsOfDate"
          [performanceInceptionDateStd]="
            pricingState.overviewData.shareClass.performanceInceptionDateStd
          "
          [fundId]="brConfig.fundId"
          (toggleChartRangeUpdated)="updatePremiumDiscountNavViivChart($event)"
        ></ft-pricing-chart>
      </div>
    </div>
  </ng-container>

  <ng-template #previewBlock>
    <h5>Premium Discount Nav to Viiv</h5>
  </ng-template>
</ng-container>
